import React from 'react';
import { SingleDatePicker } from 'react-dates'
import { Form } from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'
import useViewport from '../../../hooks/use-viewport'
import { CollectionPlay  } from 'react-bootstrap-icons'
import moment from 'moment';
import useCurrentUser from '../../../hooks/use-current-user';

const useRolloutDate = ({ course, onChange }) => {
    const [pickerVisible, setPickerVisible] = React.useState(false);
    const { breakpoint, breakpoints } = useViewport();
    const { isAdmin } = useCurrentUser();
    const collectionPlay = breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Rollout Date' : '';

    const onDateChange = (value) => {
        onChange({ ...course, rollOutDate: value ? value.toDate() : null })
    }

    const isVisible = course.private;
    const placeholder = isAdmin ? 'Optional' : 'Required';

    return {
        pickerVisible,
        setPickerVisible,
        collectionPlay,
        onDateChange,
        isVisible,
        placeholder
    }
}

const RolloutDate = ({
    course = {},
    onChange = () => {}
}) => {
    const {
        pickerVisible,
        setPickerVisible,
        isVisible,
        onDateChange,
        collectionPlay,
        placeholder
    } = useRolloutDate({
        course,
        onChange
    });

    if (!isVisible) {
        return null;
    }

    return (
        <Row>
            <Col>
                <Form.Group as={Row}>
                    <Form.Label column  sm={12} md={1} lg={1} xl={3} style={{ paddingRight: '0px' }}>
                        <CollectionPlay size={30} />  {collectionPlay}
                    </Form.Label>
                    <Col sm={12} md={11} lg={11} xl={9}>
                        <SingleDatePicker
                            placeholder={placeholder}
                            date={course.rollOutDate ? moment(course.rollOutDate) : undefined}
                            onDateChange={onDateChange}
                            focused={pickerVisible}
                            onFocusChange={({ focused }) => setPickerVisible(focused)}
                            numberOfMonths={1}
                            hideKeyboardShortcutsPanel
                            showClearDate
                            regular
                        />
                    </Col>
                </Form.Group>
            </Col>
        </Row>
    );
};

export default RolloutDate;
